import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=d8175014"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=d8175014&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/供应链金融2.0-前端-pre/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8175014')) {
      api.createRecord('d8175014', component.options)
    } else {
      api.reload('d8175014', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=d8175014", function () {
      api.rerender('d8175014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/renovation/Pagination.vue"
export default component.exports